import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45a4ea5f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=45a4ea5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4ea5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a4ea5f')) {
      api.createRecord('45a4ea5f', component.options)
    } else {
      api.reload('45a4ea5f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45a4ea5f&scoped=true&", function () {
      api.rerender('45a4ea5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pageLayout/index.vue"
export default component.exports